import { PageId } from 'constants/pages'

export const enum PageIdWoofzPpday70 {
  SUBSCRIPTIONS_PPDAY_70_N = PageId.SUBSCRIPTIONS_PPDAY_70_N,
  CHAT_UPSELL_PPDAY_70 = PageId.CHAT_UPSELL_PPDAY_70,
  UPSELL_PPDAY_70 = PageId.UPSELL_PPDAY_70,
  DOWNLOAD_PPDAY_70 = PageId.DOWNLOAD_PPDAY_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
